import { Close } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useParams } from "react-router-dom";
import ToastContext from "../../../services/Context/ToastContext";
import { useContext } from "react";
import API from "../../../services/API";
import useStore from "./useStore";
import { txt } from "../../../services/translation";

export default function ResetButton(){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)

    const {reset, status, setStatus} = useStore()


    const handleClick = () => {

        setStatus('reseting')

        API.delete(`/courses/${id}/certificate`)
            .then(r => {
                reset()
                setToast({severity: 'success', message: txt('changesSavedSuccess')})
            })
            .catch(e => {
                setToast({severity: 'error', message: txt('errorOccurred')})
                setStatus('changed')
            })
    }

    return (
        <LoadingButton 
            startIcon={<Close />} 
            onClick={handleClick}
            loading={status === 'reseting'}
            disabled={status !== 'saved'}
            variant='outlined'
            color='error'
        >
            Reset
        </LoadingButton>
    )
}